import {
  CART_DEFAULT,
  ITEMS,
  PERSONALIZATIONS_DEFAULT,
  PERSONALIZATION_PRICE,
} from "../App.constants";

export const calcTotalPrice = (
  cart = CART_DEFAULT,
  personalizations = PERSONALIZATIONS_DEFAULT,
) => {
  const baseTotal = ITEMS.reduce(
    (total, card) => total + card.price * cart[card.id],
    0,
  );

  const personalizationTotal =
    personalizations.metal.filter(Boolean).length * PERSONALIZATION_PRICE +
    personalizations.gold.filter(Boolean).length * PERSONALIZATION_PRICE +
    personalizations.wood.filter(Boolean).length * PERSONALIZATION_PRICE;

  return baseTotal + personalizationTotal;
};
